<script>
import { defineComponent, computed } from 'vue';
import { listDelimiterAPStyle } from '@kit/utils/Formats'
import ContactInfo from '@project/components/ContactInfo.vue'
import PageTitleWithArt from '@project/components/PageTitleWithArt.vue'
import { slugPageSetup } from '@kit/utils/Setup'


export default defineComponent({
  name: "Contact",
  setup() {

    const { id, prefetch } = slugPageSetup({
      routeParam: 'id',
      prefetchKey: 'contact',
      prefetchExtra: ["common"],
      metadata(contact, meta) {

        //console.log(jobTitle.value)  //for some reason the reactive computed props aren't exactly reliable here.
        const jobTitle = contact.extra_title ? `${contact.job_title} and ${contact.extra_title}` : contact.job_title

        const title  = `${contactName.value} : ${jobTitle}`
        const description = `CV, location, contact info for ${title}`

        meta.addCanonical()
        meta.addTitle('WeCare | '+contactName.value)
        meta.addMetaItem([
          { name:'description', content: description },
          { name:'og:title', content: title },
          { name:'og:description', content: description }
        ])

        if(contact.image) {
          meta.addMetaItem([
            { name:"og:image", content: contact.image },
            { name:"og:image:alt", content: `Image of ${title}` },
          ])
        }
      }

    })

    const jobTitle = computed(() => {
      return contact.value 
        ?
          contact.extra_title ? `${contact.job_title} and ${contact.extra_title}` : contact.job_title
        :
          ""
    })
    const contact = computed(() => {
      return prefetch.value ? prefetch.value.contact : null
    })
    const locations = computed(() => {
      return prefetch.value ? prefetch.value.common.locations : null
    })
    const hasContactInfo = computed(() => {
      if(!contact.value) {
        return false
      } 
      const { phone_number, fax_number, email } = contact.value 
      return phone_number || fax_number || email
    })
    const contactName = computed(() => {
      if(!contact.value) {
        return ''
      } 
      const { display_title, post_nominal } = contact.value 
      const pN = post_nominal ? `, ${post_nominal}` : ''
      return `${display_title}${pN}`
    })

    return { 
      contact, locations, contactName, listDelimiterAPStyle, hasContactInfo, jobTitle, id
    }

  },
  components: {
    ContactInfo,
    PageTitleWithArt
  }
});
</script>

<style scoped>

.profile-picture {
  width: 200px;
}

/*less than md*/
@media (max-width : 960px) {
  .profile-picture {
    width: 100%;
  }

}

</style>

<template>
 
    <main class="sb sb-v sb-greedy sb-g20 padding-lr" role="main" style="z-index:99; margin-bottom:40px;">

      <PageTitleWithArt tealText="Our team members" blackText="at WeCare" twoLines="true"/>

      <template v-if="contact">

        <section v-if="contact.image || hasContactInfo" class="sb sb-h sb-ltm-h2v sb-greedy-1">

          <div v-if="contact.image" class="sb sb-explicit profile-picture">
            <img :src="contact.image" style="width:100%; height:auto; object-fit:contain;">
          </div>
          <div class="sb sb-v sb-greedy">
            <h2 class="sb sb-text">{{contactName}}</h2>
            <h3 v-if="contact.locations.length == 0" class="sb sb-text">{{contact.job_title}}</h3>
            <h3 v-else class="sb sb-text">{{contact.job_title}} at 
              <template v-for="(location, i) in contact.locations">
                <router-link :to="`/locations/${location.post_name}`">{{location.nav_title}}</router-link>
                <span v-if="listDelimiterAPStyle(i, contact.locations.length)">{{listDelimiterAPStyle(i, contact.locations.length)}}</span>
              </template>
            </h3>
          </div>

          <ContactInfo v-if="hasContactInfo" :contact="contact"/>

        </section>
        <template v-else>
            <h2 class="sb sb-text">{{contactName}}</h2>
            <h3 v-if="contact.locations.length == 0" class="sb sb-text">{{contact.job_title}}</h3>
            <h3 v-else class="sb sb-text">{{contact.job_title}} at 
              <template v-for="(location, i) in contact.locations">
                <router-link :to="`/locations/${location.post_name}`">{{location.nav_title}}</router-link>
                <span v-if="listDelimiterAPStyle(i, contact.locations.length)">{{listDelimiterAPStyle(i, contact.locations.length)}}</span>
              </template>
            </h3>
        </template>

        <div v-if="contact.bio" class="sb sb-text">{{contact.bio}}</div>

      </template>
      <template v-else-if="!contact">

        <section class="sb sb-h sb-ltm-h2v sb-greedy-1">

          <div class="sb sb-explicit profile-picture loading-shine" style="height:150px;">
          </div>
          <div class="sb sb-v sb-greedy">
            <div class="sb sb-explicit loading-shine" style="width:200px; height:50px;"></div>
            <div class="sb sb-explicit loading-shine" style="height:40px;"></div>
          </div>

        </section>

        <div class="sb sb-explicit loading-shine" style="height:200px;"></div>

      </template>

    </main>
  
</template>

